import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import useToasts from './composables/useToasts'
import { Toast } from './types/toastsTypes'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'LFToastComponent',
  props: {
  toast: {
    type: Object as PropType<Toast>,
    required: true
  }
},
  setup(__props) {

const { toast } = __props;



const { removeToast, storageToast } = useToasts()

// METHODS
function toastIcon(icon: string) {
  return require(`@/assets/images/svg/${icon}`)
}

function removeToastLogic(toast: Toast) {
  removeToast(toast)
  toast.stored && storageToast(toast)
}

return { __sfc: true,removeToast, storageToast, toastIcon, removeToastLogic }
}

})